import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';
import './LanguageSelectionDialog.css';

interface LanguageSelectionDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const LanguageSelectionDialog: React.FC<LanguageSelectionDialogProps> = ({ isOpen, onClose }) => {
  const { currentLanguage, changeLanguage, availableLanguages } = useLanguage();
  const { t } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(currentLanguage);

  const handleLanguageSelect = async () => {
    if (selectedLanguage !== currentLanguage) {
      await changeLanguage(selectedLanguage);
    }
    onClose();
  };

  const handleCancel = () => {
    setSelectedLanguage(currentLanguage); // Reset to current language
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="language-dialog-overlay">
      <div className="language-dialog">
        <div className="language-dialog-header">
          <h2>{t('common:actions.selectLanguage')}</h2>
        </div>
        
        <div className="language-dialog-content">
          <div className="language-options">
            {availableLanguages.map((lang) => (
              <label key={lang.code} className="language-option">
                <input
                  type="radio"
                  name="language"
                  value={lang.code}
                  checked={selectedLanguage === lang.code}
                  onChange={(e) => setSelectedLanguage(e.target.value)}
                />
                <span className="language-option-text">
                  <span className="language-code">{lang.code.toUpperCase()}</span>
                  <span className="language-name">{lang.nativeName}</span>
                </span>
              </label>
            ))}
          </div>
        </div>
        
        <div className="language-dialog-actions">
          <button 
            className="language-dialog-button language-dialog-button--cancel"
            onClick={handleCancel}
          >
            {t('common:actions.cancel')}
          </button>
          <button 
            className="language-dialog-button language-dialog-button--select"
            onClick={handleLanguageSelect}
          >
            {t('common:actions.select')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageSelectionDialog;
